import React from "react";
import { FeatureFlags } from "@/cms/models";
import RippleCtaButton from "../RippleCtaButton";
import LoadingRippleButton from "../LoadingRippleButton";

const FormLayout: React.FC<{
  children: React.ReactNode;
  formAction: any;
  isPending: boolean;
  submitLabel: string;
  backLabel?: string;
  onBack?: () => void;
  featureFlags?: FeatureFlags;
}> = ({
  children,
  formAction,
  isPending,
  submitLabel,
  onBack,
  backLabel,
  featureFlags,
}) => {
  return (
    // OBS: Avoid using flex classes directly on form tags. iOS devices using OS v.17 or below font be compatible. [Casper]
    <form noValidate action={formAction}>
      <div className="re-form-fields grid grid-cols-6 w-full gap-2">
        {children}
      </div>
      <div
        className={`re-form-actions flex col-span-6 gap-2 mt-4 ${featureFlags?.reCAPTCHA ? "justify-between" : "justify-end"}`}
      >
        {featureFlags?.reCAPTCHA && (
          <div className="re-form-privacy col-span-6 homepage-text-xs">
            Dette site er beskyttet af reCAPTCHA og Google’s{" "}
            <a
              className="underline"
              target="_blank"
              href="https://policies.google.com/privacy"
            >
              privatlivspolitik
            </a>{" "}
            og{" "}
            <a
              className="underline"
              target="_blank"
              href="https://policies.google.com/terms"
            >
              servicevilkår
            </a>{" "}
            gælder.
          </div>
        )}
        <div className="re-form-buttons flex flex-row gap-2">
          {backLabel && onBack && (
            <RippleCtaButton onClick={() => onBack && onBack()}>
              {backLabel}
            </RippleCtaButton>
          )}
          <LoadingRippleButton
            className="re-form-submit"
            config={{
              bgColor: "var(--form-button-bg-color)",
              textColor: "var(--form-button-text-color)",
              hoverBgColor: "var(--form-button-hover-bg-color)",
              hoverTextColor: "var(--form-button-hover-text-color)",
            }}
            loading={isPending}
            type="submit"
          >
            {submitLabel}
          </LoadingRippleButton>
        </div>
      </div>
    </form>
  );
};

export default FormLayout;
